import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { getCtoLabel } from '../../../utils/networkMonitoring';
import { User, X, Wifi, ArrowDown, ArrowUp, Server, Terminal, Hash, AlertTriangle } from 'lucide-react';
import MonitoringServiceOrderModal from '../../modals/MonitoringServiceOrderModal';

const InfoRow = ({ icon: Icon, label, value, valueClass = '' }) => (
    <div className="flex items-center text-sm py-2 border-b border-slate-200/50 dark:border-slate-700/50">
        <Icon className="h-5 w-5 text-slate-400 mr-4 flex-shrink-0" />
        <span className="font-medium text-slate-500 dark:text-slate-400 w-24">{label}</span>
        <span className={`font-mono text-slate-700 dark:text-slate-200 break-all ${valueClass}`}>{value || 'N/A'}</span>
    </div>
);

const ClientDetailCard = ({ client, onClose, currentUser, theme, serviceOrder, onServiceOrderCreated }) => {
    const [openingOrder, setOpeningOrder] = useState(false);
    const [createdOrder, setCreatedOrder] = useState(null);
    if (!client) return null;
    const order = serviceOrder || (createdOrder?.clientId === String(client.id) ? createdOrder : null);
    const orderCreated = result => {
        setCreatedOrder({ ...result, clientId: String(client.id) });
        onServiceOrderCreated?.(client, result);
    };
    const portalTarget = document.fullscreenElement || document.querySelector('.outage-map-maximized, .outage-tv') || document.body;

    const modalContent = (
        <div style={{ zIndex: portalTarget === document.body ? 1050 : 1800 }} className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in-fast">
            <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-md border border-slate-200 dark:border-slate-700 transform animate-scale-in-fast">
                <div className="p-5 border-b border-slate-200 dark:border-slate-700 flex justify-between items-start">
                    <div className="flex items-center">
                        <div className="relative group mr-4">
                            <div className="p-3 rounded-full bg-indigo-100 dark:bg-indigo-900/40">
                                <User className="h-7 w-7 text-indigo-500 dark:text-indigo-400" />
                            </div>
                        </div>
                        <div>
                            <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100 leading-tight">{client.name}</h2>
                            <p className="text-xs text-slate-500 dark:text-slate-400 font-mono">ID: {client.id}</p>
                        </div>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-2 rounded-full text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:focus:ring-offset-slate-800"
                        aria-label="Fechar detalhes do cliente"
                    >
                        <X className="h-5 w-5" />
                    </button>
                </div>

                <div className="p-6 space-y-2">
                    <InfoRow icon={ArrowDown} label="Sinal Rx" value={`${client.signal} dBm`} valueClass={client.signal <= -27 ? 'text-red-500 font-bold' : 'text-yellow-500 font-bold'} />
                    <InfoRow icon={ArrowUp} label="Sinal Tx" value={`${client.txPower} dBm`} />
                    <InfoRow icon={Server} label="OLT" value={client.olt} />
                    <InfoRow icon={Hash} label="CTO" value={getCtoLabel(client)} />
                    <InfoRow icon={Terminal} label="PON" value={client.ponno} />
                    <InfoRow icon={Hash} label="SLOT" value={client.slotno} />
                    <InfoRow icon={Wifi} label="MAC/Serial" value={client.mac} />
                </div>

                {['administrador', 'tecnico'].includes(currentUser?.role) && <div className="p-5 bg-slate-50 dark:bg-slate-900/50 rounded-b-2xl">
                    {order ? <div role="status" className="rounded-lg bg-emerald-50 dark:bg-emerald-900/30 p-3 text-sm text-emerald-800 dark:text-emerald-200">
                        <strong>O.S. {order.orderId} já aberta no IXC.</strong>
                        {order.protocol && <p className="mt-1">Protocolo: {order.protocol}</p>}
                    </div> : <button
                        onClick={() => setOpeningOrder(true)}
                        className="w-full bg-blue-600 text-white font-bold py-3 px-4 rounded-lg hover:bg-blue-700 transition-all duration-300 disabled:bg-slate-400 disabled:cursor-not-allowed flex items-center justify-center shadow-lg hover:shadow-blue-500/50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        <AlertTriangle className="h-5 w-5 mr-2" />
                        Abrir O.S.
                    </button>}
                </div>}
            </div>
        </div>
    );

    return <>{ReactDOM.createPortal(modalContent, portalTarget)}{openingOrder && <MonitoringServiceOrderModal key={client.id} client={client} theme={theme} onCreated={orderCreated} onClose={() => setOpeningOrder(false)} />}</>;
};

export default ClientDetailCard;
